import React, { useState } from 'react';
import { Card } from '../shared/Card';
interface ListViewProps {
  workouts: any[];
}
export const ListView = ({
  workouts
}: ListViewProps) => {
  const [skipMessageVisible, setSkipMessageVisible] = useState(false);
  const showSkipMessage = () => {
    setSkipMessageVisible(true);
    setTimeout(() => setSkipMessageVisible(false), 3000);
  };
  return <div className="p-6" data-id="element-894">
      {skipMessageVisible && <div className="fixed bottom-20 left-0 right-0 mx-auto w-5/6 bg-blue-500 text-white p-4 rounded-xl shadow-lg z-10 transform transition-transform duration-300 ease-out" data-id="element-895">
          <p className="text-center" data-id="element-896">
            Life happens — we adjusted your plan to keep you on track. 👍
          </p>
        </div>}
      <div className="space-y-4" data-id="element-897">
        {workouts.map(workout => <Card key={workout.id} className={`p-4 ${workout.skipped ? 'opacity-70' : ''}`} data-id="element-898">
            <div className="flex justify-between items-center" data-id="element-899">
              <div className={workout.skipped ? 'line-through text-gray-500' : ''} data-id="element-900">
                <h3 className="font-medium" data-id="element-901">{workout.name}</h3>
                <p className="text-sm text-gray-500" data-id="element-902">{workout.date}</p>
              </div>
              {workout.completed ? <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-green-500" data-id="element-903">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-904">
                    <path d="M20 6 9 17l-5-5" data-id="element-905"></path>
                  </svg>
                </div> : workout.skipped ? <div className="text-gray-400 text-sm" data-id="element-906">Skipped</div> : <button onClick={showSkipMessage} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm" data-id="element-907">
                  Skip
                </button>}
            </div>
          </Card>)}
      </div>
    </div>;
};